import React, { useState, useMemo } from "react";

const BirthdatePicker = ({ label, onChange, errorText, required, error, disable, day, setDay, month, setMonth, year, setYear }) => {
    const currentYear = new Date().getFullYear();

    const years = useMemo(
        () => Array.from({ length: 100 }, (_, i) => currentYear - i),
        [currentYear]
    );

    const months = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" }
    ];

    const daysInMonth = useMemo(() => {
        if (!month || !year) return 31;
        return new Date(year, month, 0).getDate();
    }, [month, year]);

    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);

    const handleChange = (d, m, y) => {
        if (d && m && y) {
            onChange?.(new Date(y, m - 1, d));
        }
    };

    return (
        <div className="CustomInput">
            <div className="input-label">
                {required && <span className="input-req">* </span>}
                {label}
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
                {/* Day */}
                <select
                    className={`CustomInput-container ${error ? "error" : disable ? "disable" : ""}`}
                    value={day}
                    onChange={(e) => {
                        setDay(e.target.value);
                        handleChange(e.target.value, month, year);
                    }}
                >
                    <option value="">Day</option>
                    {days.map(d => (
                        <option key={d} value={d}>{d}</option>
                    ))}
                </select>

                {/* Month */}
                <select
                    className={`CustomInput-container ${error ? "error" : disable ? "disable" : ""}`}
                    value={month}
                    onChange={(e) => {
                        setMonth(e.target.value);
                        setDay(""); // reset day if month changes
                        handleChange("", e.target.value, year);
                    }}
                >
                    <option value="">Month</option>
                    {months.map(m => (
                        <option key={m.value} value={m.value}>{m.label}</option>
                    ))}
                </select>

                {/* Year */}
                <select
                    className={`CustomInput-container ${error ? "error" : disable ? "disable" : ""}`}
                    value={year}
                    onChange={(e) => {
                        setYear(e.target.value);
                        handleChange(day, month, e.target.value);
                    }}
                >
                    <option value="">Year</option>
                    {years.map(y => (
                        <option key={y} value={y}>{y}</option>
                    ))}
                </select>
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div>
    );
};

export default BirthdatePicker;
